import { DesiredTransactionStageDisplayValues } from '~/constants';
import { display } from '../common';
import { Project } from '~/types/project';

export default function desiredTransactionStage(project: Project) {
  return display(project?.desiredTransactionStage ? DesiredTransactionStageDisplayValues[project?.desiredTransactionStage]: '');
}